import BaseStore from "../base/BaseStore";
import { ActionInterface, StoreActionType } from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Service from "../model/service/Service";

class KeytchensStore extends BaseStore {

    private _service: Service

    constructor() {
        super();
        this._service = new Service();
    }

    public get service(): Service {
        return this._service;
    }

    setService(service: Service) {
        this._service = service;
        this.emitChange();
    }

}

const storeActions = (store: KeytchensStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {
            case StoreActionType.SET_KEYTCHENS_SERVICE:
                store.setService(action.data);
                break;
        }
    }
};

const KeytchensStoreShared = new KeytchensStore();
KeytchensStoreShared.dispatchToken = AppDispatcher.register(storeActions(KeytchensStoreShared) as (payload: unknown) => void);

export default KeytchensStoreShared;
export const store = KeytchensStore;
export const action = storeActions;